import { Link } from "@/components/CustomLink";
import CardButton from "./CardButton";
import { useSearchContext } from "@/lib/hooks/searchContext/searchStore";
import { DEFAULT_IMAGES } from "@/lib/constants";
import Image from "next/image";
import { useState } from "react";
import S3Image from "@/components/S3Image";
import { useHeader } from "@/hooks/headerContext";

export default function CompanyCard({
  logo,
  title,
  discount,
  id,
  venue,
  shortDescription,
  slug,
}: {
  logo: string;
  title: string;
  discount: number;
  id: number;
  venue: {
    id: number;
    title: string;
  };
  shortDescription: string;
  slug: string;
}) {
  const { service, district } = useHeader();

  const getHrefUrl = () => {
    const searchParams = new URLSearchParams();

    if (district?.slug) searchParams.append("district", district.slug);
    if (service?.slug) searchParams.append("service", service.slug);

    const queryString = searchParams.toString();
    return queryString ? `/${slug}-indirimleri?${queryString}` : `/${slug}-indirimleri`;
  };

  return (
    <article className="flex justify-center gap-2 p-4 rounded-2xl border border-gray-secondary w-[389px] items-center relative">
      <Link
        className="absolute rounded-2xl left-0 right-0 w-full h-full z-10"
        href={getHrefUrl()}
      ></Link>

      <S3Image
        sizes="92px"
        width={92}
        height={92}
        // onError={() => {
        //   setImageSrc(DEFAULT_IMAGES.COMPANY_LOGO_LARGE);
        /*}}*/
        src={`company/${id}/logo/${logo}`}
        className="w-[92px] border border-white shadow-md h-[85px] rounded-2xl"
        alt={title}
      />

      <div className="w-[217px] flex flex-col items-start">
        <h2 className="text-base font-bold text-primary">{title}</h2>
        {shortDescription && (
          <p className="text-assistant font-medium text-xs">
            {shortDescription}
          </p>
        )}
      </div>

      <CardButton
        id={id}
        company={title}
        discount={discount}
        venue={venue}
        banner={logo}
      />
    </article>
  );
}
